import { memo } from 'react';

import { RegisterInbound, RegisterOutbound } from '~features/annals';
import { annals } from '~features/annals/hooks';
import { useRequireAuth } from '~features/auth';
import { useCurrentBot } from '~hooks/useCurrentBot';

import { useInitiateTopic } from '../../model/useInitiateTopic';
import { useTopics } from '../../model/useTopics';
import { Topic } from '../Topic';
import { Container, List } from './styles';

type Props = {
	recipientId: string;
	onClick: () => void;
};

export const TopicList = memo<Props>(
	({ recipientId, onClick }) => {
		const topics = useTopics(recipientId);
		const { bot } = useCurrentBot({ recipientId });
		const annalsTopicClick = annals.chat.useChatClickTopic();
		const [initiateTopic, activeTopicId] = useInitiateTopic(recipientId);
		const withRequireAuth = useRequireAuth();

		const initiate = withRequireAuth(
			(id: string, topicName: string) => {
				void initiateTopic(id);
				annalsTopicClick({
					bot_UserId: recipientId,
					bot_name: bot?.name ?? 'noname',
					theme: topicName,
				});
				onClick();
			},
			{
				analytics: {
					inbound:
						bot.accountType === 'user-generated'
							? RegisterInbound.ChatClickTopicUDC
							: RegisterInbound.ChatClickTopic,
					outbound: RegisterOutbound.Chat,
				},
			}
		);

		const views = topics.map((topic) => (
			<Topic
				key={topic.Id}
				topic={topic}
				processing={topic.Id === activeTopicId}
				disabled={!!activeTopicId && topic.Id !== activeTopicId}
				onClick={initiate}
			/>
		));

		return topics.length > 0 ? (
			<Container>
				<List>{views}</List>
			</Container>
		) : null;
	},
	(prevProps, nextProps) => nextProps.recipientId === prevProps.recipientId
);
TopicList.displayName = 'TopicList';
